import { gql } from '@apollo/client';

/**
 * RITA-1522 (Nutzungserfassung Phase 3d) — Klickkarte der AKTUELLEN Seite für das Overlay.
 *
 * Drittes Dokument der Lese-API neben GetUsageInsights und GetUsageErrors, und das einzige, das
 * außerhalb der Auswertungsseite läuft: das Overlay liegt über jeder beliebigen Maske.
 *
 * Alle vier eigenen Argumente sind Pflicht und werden serverseitig hart geprüft
 * (usageRangeArgs.ts) — ein unzulässiger Wert wird abgelehnt und nie still ersetzt. Deshalb
 * stehen sie als benannte Variablen hier und nicht als Vorgabewerte im Client.
 *
 * Gefragt wird JEDES Feld von UsageClickMap. Die Leiste erklärt, was die Karte NICHT zeigt
 * (dropped*, hiddenElements, truncated, suppressed); ein weggelassenes Feld machte die Karte
 * stillschweigend vollständiger, als sie ist. `users`, `clicks` und `elements` gelten für die
 * ganze Seite, die Zellen nur für die abgefragte Fensterklasse und Menüführung (usage.graphql).
 */
const GET_USAGE_CLICK_MAP = gql`
  query GetUsageClickMap(
    $route: String!
    $viewportWidth: Int!
    $themeLayout: String!
    $themeStretch: Boolean!
    $range: UsageRangeInput!
  ) {
    usageClickMap(
      route: $route
      viewportWidth: $viewportWidth
      themeLayout: $themeLayout
      themeStretch: $themeStretch
      range: $range
    ) {
      route
      viewportClass
      dataFrom
      dataUntil
      users
      usersEstimated
      clicks
      suppressed
      truncated
      droppedSynthetic
      droppedFixed
      droppedLayout
      hiddenElements
      cells {
        x
        y
        count
      }
      elements {
        key
        kind
        count
        users
      }
    }
  }
`;

export default GET_USAGE_CLICK_MAP;
